export const SMART_HUB_2_PRODUCT = 'Smart Hub 2';
export const SMART_HUB_3_PRODUCT = 'Smart Hub 3';
export const HYBRID_CONNECT_PRODUCT = 'Hybrid Connect Device';
